(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    const bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    // IMPORTANT: the real ATC button in Symmetry is: .add-to-cart
    const atcBtn = document.querySelector('.add-to-cart');
    if (!atcBtn) return;

    const stickyBtn = bar.querySelector('[data-sticky-atc-btn]');
    if (!stickyBtn) return;

    // Show only on mobile
    const mq = window.matchMedia('(max-width: 989px)');
    function isMobile() { return mq.matches; }

    // Smooth scroll to real ATC (UX > forcing click)
    stickyBtn.addEventListener('click', function () {
      atcBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Optional: small focus hint
      setTimeout(() => {
        try { atcBtn.focus({ preventScroll: true }); } catch(e) {}
      }, 350);
    });

    // IntersectionObserver: if ATC is visible -> hide sticky, else show after scroll
    let atcVisible = true;
    let scrolledEnough = false;

    const io = new IntersectionObserver((entries) => {
      atcVisible = entries[0]?.isIntersecting ?? false;
      update();
    }, { threshold: 0.15 });

    io.observe(atcBtn);

    function update() {
      if (!isMobile()) {
        bar.classList.remove('is-visible');
        bar.hidden = true;
        return;
      }

      // show only after user scrolls a bit and ATC is not visible
      const shouldShow = scrolledEnough && !atcVisible;

      bar.hidden = !shouldShow;
      if (shouldShow) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }

    function onScroll() {
      // wait some scroll before showing, otherwise it flashes at top
      scrolledEnough = window.scrollY > 220;
      update();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    mq.addEventListener?.('change', update);

    // init
    onScroll();
  });
})();
